import React, { useRef, useState } from "react";
import Countdown from 'react-countdown'
import { Link } from "react-router-dom";
import axios from 'axios';
import '../inc/GlobalVars';
import { ToastContainer, toast } from 'react-toastify';
import   submitBid   from "../inc/hooks/submitBid";
//require('../inc/hooks/useSubmitBid');
function AuctionList(props) {

//const submitBid = useSubmitBid();
 
    const renderer = ({days,hours,minutes,seconds}) => {
        return(
            <div style={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
                <div style={{display:"flex",flexDirection:"column"}}><span className="time fw-bold">{days}</span><span className="text-white">Days</span></div>
                <span></span>
                <div style={{display:"flex",flexDirection:"column"}}><span className="time fw-bold">{hours}</span><span className="text-white">Hours</span></div>
                <span></span>
                <div style={{display:"flex",flexDirection:"column"}}><span className="time fw-bold">{minutes}</span><span className="text-white">Min</span></div>
                <span></span>
                <div style={{display:"flex",flexDirection:"column"}}><span className="time fw-bold">{seconds}</span><span className="text-white">Sec</span></div>
                
            </div>
        )
    }
const [res, setRes] = useState('');
const user_id = localStorage.getItem('userId');    
const dateString = props.expiry_date;
const timeString = props.expiry_time;
const a= dateString+"T"+timeString;
const [watchListStatus,setWatchListStatus] = useState(props.watchlist === "yes" ? "added" : "not_added");

const timestamp = Date.parse(dateString);
const bidId = useRef(null);
const bidNow = (vehicleId) => {
  bidId.current.value = vehicleId;
};

const watchlistId = useRef(null);
const addToWatchlist = (vehicleId) => {
  //watchlistId.current.value = vehicleId;
  const watchlist = {user_id:user_id,vehicle_id:vehicleId}
  
  axios.post(global.apiUrl+'/addToWatchList',JSON.stringify(watchlist)).then(function(response)
  {
      let status= response.data['status'];
      if(status == 400)
      {
          alert("Something Went Wrong");
      }
      else
      {
        setWatchListStatus("added");
        toast.success('Added To Watchlist!', {
          position: "top-left",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          });
      }

  }

  )
};

const removeFromWatchlist = (vehicleId) => {
  //watchlistId.current.value = vehicleId;
  const watchlist = {user_id:user_id,vehicle_id:vehicleId}
  
  axios.post(global.apiUrl+'/removeFromWatchList',JSON.stringify(watchlist)).then(function(response)
  {
      let status= response.data['status'];
      if(status == 400)
      {
          alert("Something Went Wrong");
      }
      else
      {
        setWatchListStatus("not_added");
        toast.success('Vehicle Removed From Watchlist', {
          position: "top-left",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          });
      }

  }

  )
};


const data = { bid_amount:""}
const [inputData, setInputData] = useState(data);

const handleData = (e) =>
{
    setInputData({...inputData,[e.target.name]:e.target.value});
}

const handleBidding = async (e) => {
  e.preventDefault();
  const bid_amount = inputData.bid_amount;
  const vehicleId = bidId.current.value; // Get vehicle ID from form
  const res = await submitBid(bid_amount, vehicleId);
  setRes(res);
 // await submitBid(bid_amount, vehicleId);
};

    
  return (
    
    <div className='col-md-4 mt-4'>
           <ToastContainer
position="bottom-left"
autoClose={1000}
hideProgressBar={true}
newestOnTop={false}
closeOnClick
rtl={false}

theme="colored"
/>
            <div className='carCard text-center position-relative'>
            
            <span className={props.bid_win_status == "no" ? "text-white bid-status-loosing" : "text-white bid-status-win"} style={{fontWeight:"bold"}}>{props.bid_win_status == "no" ? "Losing" : "Winning"}</span>

            <Link to={"/vehicleDetails/"+props.vehicle_id} className="text-decoration-none text-black"><img src={global.apiUrl +"/"+props.featured_image}
              className="img-fluid carCarImage" style={{aspectRatio:"1.2/1"}} /></Link>
              {
              watchListStatus === "added" || props.watchlist === "yes" ? 
              (
                <button className="btn btn-watchlist" onClick={() => removeFromWatchlist(props.vehicle_id)}>Remove From WatchList</button>
              )
              :
              (
                <button className="btn btn-watchlist" onClick={() => addToWatchlist(props.vehicle_id)}>Add To WatchList</button>

              )

            }

{user_id==null ? (
                <>
                 <Link
                        className="text-decoration-none "
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                      >
                        <h3 style={{textTransform:"capitalize",fontSize:"18px",marginTop:"10px"}}>{props.make_name+" "+props.model}</h3>
                      </Link>
                </>
              ) : (
                <Link target="_blank" to={"/vehicleDetails/"+props.vehicle_id} className="text-decoration-none text-black"><h3 style={{textTransform:"capitalize",fontSize:"18px",marginTop:"10px"}}>{props.make_name+" "+props.model+" "+props.variant+" ("+props.year+")"}</h3></Link>

              )
            }
                <ul className="list-group">
              <li className="list-group-item  d-flex justify-content-between align-items-center">
              <span  style={{textTransform:"uppercase"}}>{props.reg_number}</span>
              <span className="">RC<span className={props.rc_availability === '1' ? "text-success fw-bold" : "text-danger fw-bold"}> {props.rc_availability === '1' ? "Yes" : "No"}</span></span>

                
              </li>
              <li className="list-group-item  d-flex justify-content-between align-items-center">
                <span className="">Owners: {props.owners}</span>
                
              <span  style={{textTransform:"capitalize"}}>{props.transmission}</span>
              </li>
              <li className="list-group-item  d-flex justify-content-between align-items-center">
              <div>Contact</div>
                <div className="text-end">
                <span className="text-end" style={{textTransform:"capitalize"}}>{props.cname}</span><br/>
                <span className="text-end">{props.cmobile}</span>
                </div>
              </li>
              <li className="list-group-item  d-flex justify-content-between align-items-center">
                <span className="text-start">BID Amount</span>
                <span >&#8377; {props.bid_max_amount == null ? "0" : props.bid_max_amount}</span>
              </li>
              <li className="list-group-item  d-flex justify-content-center align-items-center">
                
                <span >{props.location+" ("+props.state+")"}</span>
              </li>
            </ul>
            {user_id==null ? (
                <>
                 <Link
                        className="btn btn-primary carCardButton"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                      >
                        Login/Signup To Bid
                      </Link>
                </>
              ) : (
                <button onClick={() => bidNow(props.vehicle_id)} value={props.vehicle_id} data-bs-toggle="modal" data-bs-target={"#exampleModal"+props.vehicle_id} className="btn btn-primary carCardButton">BID NOW</button>

              )
            }

                
                </div>
                <div className='carCardCounter text-center'>
               
                    <Countdown date={dateString+"T"+timeString} renderer={renderer} />
                </div>


                <div className="modal fade" id={"exampleModal"+props.vehicle_id} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content" style={{background:"#edfbfb"}}>
      <div className="modal-header p-0 m-0" >
        <img src={global.apiUrl +"/"+props.featured_image} className="img-fluid" style={{display:"none"}} />
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" style={{position: "absolute",
    right: "-7px",
    color: "#fff",
    top: "-4px",
    filter: "invert(1)"}}></button>
      </div>
      <div className="modal-body">
      {props.can_bid == "yes" ? (
        <>
        <form method="POST" encType="multipart/form-data">
        
          <input type="hidden" name="user_id" value={user_id} />
          <input type="hidden" name="vehicle_id" ref={bidId} />
          <h3 style={{textTransform:"capitalize",textAlign:"center"}}>{props.make_name+" "+props.model+" "+props.variant+" ("+props.year+")"}</h3>
          <h5 className="text-center">{props.reg_number}</h5>
            <ul className="list-group">
              
              <li className="list-group-item  d-flex justify-content-between align-items-center">
                <span className="text-start">BID Status</span>
                <span className={props.bid_win_status == "no" ? "text-white bid-status-loosing" : "text-white bid-status-win"} style={{fontWeight:"bold"}}>{props.bid_win_status == "no" ? "Losing" : "Winning"}</span>

              </li>
              <li className="list-group-item  d-flex justify-content-between align-items-center">
                <span className="text-start">BID Amount</span>
                <span className="fw-bold">&#8377; {props.bid_max_amount == null ? "0" : props.bid_max_amount}</span>
              </li>
              

            </ul>
          <div className="mb-2 mt-4 input-wrapper">
            <label>Bid Amount <span className="text-danger">*</span></label>
            <input type="text" className="form-control"  value={inputData.bid_amount} onChange={handleData} placeholder="Enter Bid Amount" name="bid_amount" required />
          </div>
          <div className="mt-3">
            <button type="submit" onClick={handleBidding} className="btn btn-primary carCardButton" >Submit Now</button>
          </div>
          
          <div className='carCardCounter text-center'>
                    <Countdown date={dateString+"T"+timeString} renderer={renderer} />
                </div>
                {res != null ? (
                  <div className="text-center mt-2" style={{padding:"4px 5px",borderRadius:"5px"}}>
                <h4 className="text-danger text-danger" >{res}</h4>
                </div>
                ) : ''}
                
                
          </form>
        </>) : (
                  <>
                  <input type="hidden" name="user_id" value={user_id} />
                  <input type="hidden" name="vehicle_id" ref={bidId} />
                  <h3 style={{textTransform:"capitalize",textAlign:"center"}}>Place Your Bid</h3>
                  <p className="text-center text-danger"><b>You are restricted to place bid on this vehicle</b></p>
                </>
                )}
      </div>
      
    </div>
  </div>
</div>
        </div>
  );
}

export default AuctionList;
